export const imageCacheId = 'images'

export async function imagesCache() {
  return caches.open(imageCacheId)
}
